export default {
  rollover: {
    title: 'Vòng cược',
    detailsTitle: 'Chi tiết vòng cược',
    all: 'Tất cả',
    allStats: 'Tất cả trạng thái',
    select: 'Chọn',
    rolloverType: 'Loại vòng cược',
    amount: 'Số tiền',
    source: 'Nguồn',
    wallet: 'Ví',
    current: 'Hiện tại',
    wagered: 'Đã cược',
    required: 'Yêu cầu',
    progress: 'Tiến độ',
    loading: 'Đang tải...',
    noData: 'Không có dữ liệu',
    noMoreData: 'Không còn dữ liệu',
    state: 'Trạng thái',
    type: 'Loại',
    createdOn: 'Tạo lúc',
    wageringRequirement: 'Yêu cầu cược',
    currency: 'Tiền tệ',
    wagerRequired: 'Mức cược yêu cầu',
    wagerCompleted: 'Mức cược hoàn thành',
    cash: 'Tiền mặt',
    bonus: 'Thưởng',
  },
};
